import type { RuntimeConfig } from '@ccex/shared';
import { RuntimeConfigSchema } from '@ccex/shared';

export const RUNTIME_CONFIG_URL = '/config.json';
const TIMEOUT_MS = 3_000;

/**
 * Served by nginx from the Helm ConfigMap (spec 2026-10-08 §3.1). Anything but a well-formed
 * JSON answer means "no monitoring": under `vite dev` the SPA fallback returns index.html,
 * and a Playwright run never sees a config. Never throws, never blocks mounting beyond the timeout.
 */
export async function loadRuntimeConfig(
  fetchImpl: typeof fetch = fetch,
): Promise<RuntimeConfig | null> {
  try {
    const response = await fetchImpl(RUNTIME_CONFIG_URL, {
      headers: { accept: 'application/json' },
      signal: AbortSignal.timeout(TIMEOUT_MS),
    });
    if (!response.ok) return null;
    if (!(response.headers.get('content-type') ?? '').includes('application/json')) return null;
    const parsed = RuntimeConfigSchema.safeParse(await response.json());
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}
